module.exports = __webpack_public_path__ + "media/promo/courses/images/s2-5602f3b9975e263cdcff00caeb24f994.svg";